// extracted by mini-css-extract-plugin
module.exports = {"loading_box":"loading_box-4fd4d694670bbacf02f9fc3a18abbddf","finished_tip":"finished_tip-603d1f5bedd13ca96abc0464dab43585"};